import React from "react";
import { motion } from "framer-motion";

import Hero from "../components/Hero";
import About from "../components/About";
import Features from "../components/Features";
import Screenshots from "../components/Screenshots";
import DownloadCTA from "../components/DownloadCTA";
import SEOHead from "../components/SEOHead";
import { getSEOConfig } from "../utils/seoConfig";
import PrePost3DSection from "../components/PrePost3DSection/PrePost3DSection";

import "./homeProduct.css";
import Dashboard from "./Dashboard";
import PWAInstallBanner from "../components/PWAInstallBanner";
import IOSInstallHint from "../components/IOSInstallHint";

const isLoggedIn = () => {
  return !!localStorage.getItem("token");
};

const HomePage: React.FC = () => {
  const seoConfig = getSEOConfig("/");
  const loggedIn = isLoggedIn();

  return (
    <>
      <SEOHead
        title={seoConfig.title}
        description={seoConfig.description}
        keywords={seoConfig.keywords}
        ogType={seoConfig.ogType}
      />

      {!loggedIn ? (
        <>
        
          <PWAInstallBanner />
          <IOSInstallHint />
          {/* MARKETING HOME */}
          <motion.div
            id="home"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Hero />
          </motion.div>

          
          <About />
          <Features />
          <Screenshots />
          <DownloadCTA />
          {/* <PrePost3DSection /> */}
        </>
      ) : (
        <>
          {/* PRODUCT HOME */}
          <Dashboard />
        </>
      )}
    </>
  );
};

export default HomePage;

/* ---------------------------
   PRODUCT HUB SECTION
---------------------------- */
// function ProductHub() {
//   return (
//     <motion.div
//       className="product-hub"
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.6 }}
//     >
//       {/* HERO */}
//       <section className="hub-hero">
//         <h1>Your creative workspace</h1>
//         <p>Create, enhance and publish content with AI-powered tools.</p>
//       </section>

//       {/* ACTIONS */}
//       <section className="hub-actions">
//         <ActionTile title="Create Post" color="yellow" />
//         <ActionTile title="AI Generate" color="purple" />
//         <ActionTile title="Auto Fix" color="blue" />
//         <ActionTile title="My Posts" color="green" />
//       </section>

//       {/* FEED */}
//       <section className="hub-feed">
//         <h2>Latest posts</h2>
//         <div className="feed-row">
//           <div className="feed-box shimmer" />
//           <div className="feed-box shimmer" />
//           <div className="feed-box shimmer" />
//         </div>
//       </section>
//     </motion.div>
//   );
// }

// function ActionTile({
//   title,
//   color,
// }: {
//   title: string;
//   color: "yellow" | "purple" | "blue" | "green";
// }) {
//   return (
//     <motion.div
//       className={`hub-tile ${color}`}
//       whileHover={{ y: -6, scale: 1.04 }}
//       whileTap={{ scale: 0.96 }}
//       transition={{ type: "spring", stiffness: 200 }}
//     >
//       {title}
//     </motion.div>
//   );
// }
